import moment from "moment";
import React from "react";
import Checkbox from "../../common/Checkbox";
import Modal, { ModalBody, ModalFooter, ModalHeader } from "../../common/Modal";
import "./index.css";

class AddViewComments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValid: false,
      showAddComment: "showAddComment" in this.props ? this.props.showAddComment : true
    };
  }

  componentWillReceiveProps(nextProps) {
    if ("showAddComment" in this.props && this.props.showAddComment !== nextProps.showAddComment) {
      this.setState({
        showAddComment: nextProps.showAddComment
      })
    }
  }

  handleInputChange = (event) => {
    let inputValid = true;
    const comment = event.target.value;
    if (comment === undefined || comment === '') {
      inputValid = false;
    }
    this.setState({
      comment,
      inputValid
    });
  }

  _onAddComment = () => {
    this.setState({ comment: '' });
    this.props._onAddComment(this.props.product.id, this.state.comment);
    if (this.props.hideFooter) {
      this.setState({ noComments: false, comment: undefined })
    }
  }

  render() {
    return (
      <Modal
        show={this.props.showDialog}
        onClose={() => {
          this.props.toggleDialog()
          this.setState({ noComments: false, comment: undefined })
        }}
        bsClass={this.props.bsClass}
      >
        <ModalHeader title={this.props.modalTitle} />
        <ModalBody>
          <div className="product-deatails">
            <label className="product-desc">{this.props.product.glsProductType.name}</label>
            {this.props.sow ? null : <label className="product-desc">Agent: {this.props.product.glsAgent.name} ({this.props.product.title})</label>}
          </div>
          <div className="comments-conatiner">
            {this.props.noCommentProps && this.props.noCommentProps.show ?
              <div className='sow-comments-section__guide-text'>
                <i className='icon gdocs-banner__icon icon-circle-error-solid gdocs-banner__icon--primary'></i>
                <span>Please select the checkbox below if you have no comments to add.</span>
              </div> : null
            }
            {this.state.showAddComment ?
              <div className="add-comments-section">
                <label htmlFor="add-comment">{this.props.addCommentLabel}</label>
                <textarea
                  name="add-comment"
                  id="add-comment"
                  value={this.state.comment}
                  onChange={this.handleInputChange}
                  disabled={this.state.noComments}
                ></textarea>

                <div className="comments-section-flex-container">
                  {this.props.noCommentProps && this.props.noCommentProps.show ?
                    <div className="comments-section-checkbox">
                      <Checkbox
                        name={this.props.noCommentProps.name}
                        onChange={(e) => {
                          this.setState({
                            noComments: e.target.checked,
                            comment: e.target.checked ? 'no comments' : ''
                          })
                        }}
                        checked={this.state.comment === "no comments"}
                        controlled={true}
                      ></Checkbox>
                      <section>{this.props.noCommentProps.text}</section>
                    </div> : null
                  }

                  <button
                    className="gdocs-btn-primary comments-section-button"
                    onClick={this._onAddComment}
                    disabled={!(this.state.comment || this.state.noComments)}
                  >
                    {this.props.addCommentBtn}
                  </button>
                </div>
              </div>
              : null}
            <div className="previous-comments-section">
              <h5>{this.props.prevCommentsLabel}</h5>
              <ul className="comments-list">
                {
                  Array.isArray(this.props.comments) && this.props.comments.map((comment, index) => (
                    <li className="comments-list__item" key={index}>
                      <div className={this.props.from === "sow-documentation-tab" ? "gdocs-display-block comments-list__item__comment-details" : "comments-list__item__comment-details"}>
                        <div className="comments-list__item__info">
                          <label className="username">{this.props.sow ? comment.username : comment.userName}</label>
                          <label className="time-stamp">{`${moment(this.props.sow ? comment.createdOn : comment.sentOn).format("DD MMM YY, h:mm")}`}</label>
                        </div>
                        <label className="comment-email">{this.props.sow ? comment.email : ''}</label>
                      </div>
                      <div className="comments-list__item__comment">
                        {
                          comment.headerText ? <label className="header">{comment.headerText}</label> : ''
                        }
                        <p className="comment-text">{this.props.sow ? comment.commentText : comment.comment}</p>
                      </div>
                    </li>
                  ))
                }
              </ul>
            </div>
          </div>
        </ModalBody>
        {
          this.props.hideFooter ? null :
            <ModalFooter>
              <hr></hr>
              <button
                className="gdocs-btn-primary"
                onClick={() => {
                  this.props.toggleDialog()
                  this.setState({ noComments: false, comment: undefined })
                }}
              >
                {this.props.doneBtn}
              </button>
            </ModalFooter>
        }
      </Modal>
    )
  }
}

export default AddViewComments


// WEBPACK FOOTER //
// ./src/components/SowBody/AddViewComments/index.js